import React from 'react';
import { Tooltip as TooltipStandard } from '@emorg-prd/standard-react';
import './Tooltip.css';

export enum Type {
	Icon = 'em-c-tooltip--icon',
}

export type TooltipType = 'icon';

interface TooltipProps extends Omit<React.ComponentProps<typeof TooltipStandard>, 'type'> {
	disabled?: boolean;
	name?: any;
	type?: TooltipType;
	optionalClass?: string;
}

const TooltiptMap: Record<TooltipType, Type> = {
	icon: Type.Icon,
};

const Tooltip: React.FC<TooltipProps> = (props) => {
	const mappedType = props.type ? TooltiptMap[props.type] : undefined;

	return (
		<>
			{props.disabled != true ? (
				<>
					<TooltipStandard
						{...props}
						optionalClass={'tooltip_custom ' + props.optionalClass}
						type={mappedType}
					>
						{props.children}
					</TooltipStandard>
				</>
			) : null}
		</>
	);
};

export { Tooltip };